import { get } from 'lodash-es';
/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { select, call } from 'redux-saga/effects';

import { uncurlyUuid } from '@atlassian/bitkit-analytics';

import { Repository } from 'src/components/types';
import {
  getPullRequestDestinationRepo,
  getPullRequestSourceRepo,
  getCurrentPullRequestId,
  getPullRequestDiffFileCount,
  getPullRequestDiffLinesCount,
} from 'src/redux/pull-request/selectors';
import { PullRequestFact } from 'src/sections/repository/sections/pull-request/facts';
import { publishFact } from 'src/utils/analytics/publish';

type FactAction = {
  type: string;
  payload: {
    name: string;
    extraFactData?: object;
  };
};

function* getBasePullRequestFactData() {
  const pullRequestId: number = yield select(getCurrentPullRequestId);
  const sourceRepo: Repository = yield select(getPullRequestSourceRepo);
  const destRepo: Repository = yield select(getPullRequestDestinationRepo);

  // With a pull request, it's possible for source repos to have
  // been deleted, but not destination repos.
  if (!destRepo) {
    return null;
  }

  return {
    from_repository_uuid: uncurlyUuid(get(sourceRepo, 'uuid', '')),
    pull_request_id: pullRequestId,
    to_repository_uuid: uncurlyUuid(destRepo.uuid),
    to_repository_owner_uuid: uncurlyUuid(get(destRepo, 'owner.uuid', null)),
  };
}

function* makePullRequestBaseFact(action: FactAction) {
  if (!action || !action.payload) {
    return null;
  }

  const eventName = action.payload.name;
  if (!eventName) {
    return null;
  }

  // @ts-ignore
  const prFactData = yield getBasePullRequestFactData();
  if (!prFactData) {
    return null;
  }

  const factData = {
    ...prFactData,
    ...action.payload.extraFactData,
  };

  return new PullRequestFact(eventName, factData);
}

export function* publishBasePullRequestFactSaga(action: FactAction) {
  // @ts-ignore
  const fact = yield makePullRequestBaseFact(action);
  if (!fact) {
    return;
  }

  yield call(publishFact, fact);
}

export function* publishPullRequestDiffFactSaga(action: FactAction) {
  // @ts-ignore
  const fact = yield makePullRequestBaseFact(action);
  if (!fact) {
    return;
  }
  // @ts-ignore
  fact.data.number_of_diff_lines = yield select(getPullRequestDiffLinesCount);
  // @ts-ignore
  fact.data.number_of_files = yield select(getPullRequestDiffFileCount);

  yield call(publishFact, fact);
}
